import { request } from "@/lib/api"
import { type Visao, VisaoSchema } from "./schema"

// O CNPJ do empregador sai do token, no authorizer — nunca da rota. É o que impede trocar o
// identificador na URL e enxergar outra empresa.
//
// A rota mora no baas-broker, e não no condo-loan-async como a do repasse: é lá que vive a coleção
// de leilões, e uma agregação desse tamanho não deveria atravessar um salto de serviço.
export const fetchVisao = async (): Promise<Visao> =>
    request("/baas-broker/employer/insights", VisaoSchema)
